function initialValues() {
  return {
    phone: '',
  };
}

export default initialValues;
